import React from 'react';
import cn from 'classnames';
import {useTranslation} from 'react-i18next';
import Button from '../../acommon/Button';
import styles from '../ConfirmIdentityTemplate.module.sass';

const Buttons = React.memo(
  ({
    screenshot,
    onSend,
    onCapture,
    isCaptureButtonDisabled,
    onRetry,
    disabled,
    withCapture = true,
  }: any) => {
    const {t} = useTranslation();

    if (screenshot)
      return (
        <>
          <Button
            onClick={() => onSend(screenshot)}
            size="large"
            disabled={disabled}
            className={styles.button}
            label={t('next')}
          />
          <button disabled={disabled} className={styles.tryAgain} onClick={onRetry}>
            {t('try_again')}
          </button>
        </>
      );
    if (withCapture)
      return (
        <Button
          onClick={onCapture}
          disabled={isCaptureButtonDisabled || disabled}
          size="large"
          className={cn(styles.button, styles.capture)}
          secondary
          label={t('capture')}
        />
      );
    return null;
  },
);

export {Buttons};
